import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
interface InviteHistoryListItemProps {
  daysAgo: string;
  eventDisplayText: string;
  rewardPoint: number;
  hideLine?: boolean;
}
export const InviteHistoryListItem = t0 => {
  const $ = _c(18);
  const {
    daysAgo,
    eventDisplayText,
    rewardPoint,
    hideLine
  } = t0;
  let t1;
  if ($[0] !== hideLine) {
    t1 = cn("flex items-center justify-between border-b border-Gray-200 py-16", {
      "border-0": hideLine
    });
    $[0] = hideLine;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== eventDisplayText) {
    t2 = <p className="font-500 text-Gray-900 typo-body4">{eventDisplayText}</p>;
    $[2] = eventDisplayText;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== daysAgo) {
    t3 = <p className="font-400 text-Gray-600 typo-caption1">{daysAgo}</p>;
    $[4] = daysAgo;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-col gap-2">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = rewardPoint >= 0 ? "+" : "";
  let t6;
  if ($[9] !== rewardPoint) {
    t6 = rewardPoint.toLocaleString();
    $[9] = rewardPoint;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <p className="text-nowrap font-700 text-B-500 typo-body3">{t5}{t6}원</p>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t1 || $[15] !== t4 || $[16] !== t7) {
    t8 = <li className={t1}>{t4}{t7}</li>;
    $[14] = t1;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};